import { render } from "./AccountDefaultSettings_backup20250209.vue?vue&type=template&id=2903d03a&scoped=true"
import script from "./AccountDefaultSettings_backup20250209.vue?vue&type=script&lang=js"
export * from "./AccountDefaultSettings_backup20250209.vue?vue&type=script&lang=js"

import "./AccountDefaultSettings_backup20250209.vue?vue&type=style&index=0&id=2903d03a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2903d03a"]])

export default __exports__